
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book-subscriptions",
      function () {
        return require("private-next-pages/book-subscriptions/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/book-subscriptions"])
      });
    }
  